import { render, staticRenderFns } from "./ItemWriteDefaultLayout.vue?vue&type=template&id=a39968ca&scoped=true&"
import script from "./ItemWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./ItemWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39968ca",
  null
  
)

export default component.exports